import { axiosMeedioClient } from './client';

interface EndMeetingResponse {
  ended_at: string;
  /**
   * `true` when this call was the first-ever end of the current occurrence.
   * Use to emit `MEETING_ENDED` exactly once; false on rejoin+leave cycles.
   */
  ended_now: boolean;
}

export const endMeeting = async (meetingId: string): Promise<EndMeetingResponse> => {
  const { data } = await axiosMeedioClient.patch<EndMeetingResponse>(`/meetings/${meetingId}/end`, {});
  return data;
};
